export default __webpack_public_path__ + "static/media/globe.b264e6c5.svg";